import { InitialModel, UserModel, UserType } from '../models/user.model';
import { getRandomAvatarColorStyles } from './color.utils';

export function getUserInitials(user: UserModel): InitialModel {
  if (!user) {
    return null;
  }
  if (!user.firstname || !user.lastname) {
    return null;
  }
  const userText = `${user.firstname?.charAt(0)}${user.lastname?.charAt(0)}`;
  if (user.type === UserType.COOPERATION && !user.cooperationName) {
    return null;
  }
  const cooperationText = user.cooperationName?.charAt(0);
  const text = user.type === UserType.COOPERATION ? cooperationText : userText;
  const colors = getRandomAvatarColorStyles();
  return {
    backgroundColor: colors.background,
    color: colors.font,
    text: text.toUpperCase(),
  };
}

export function getUserFullName(user: UserModel): string {
  if (!user) {
    return null;
  }
  return `${user.firstname} ${user.lastname}`;
}

export function getTableNameValue(user: UserModel): string {
  if (!user) {
    return null;
  }
  if (user.type === UserType.COOPERATION) {
    return user.cooperationName;
  }
  return `${user.firstname} ${user.lastname}`;
}
